import {
    USER_LOGIN_SUCCESS,
    USER_LOGIN_FAILURE,
    USER_LOADED,
    USER_LOGOUT,
    USER_AUTH_ERROR
} from '../actions/types';


//storing state for USERs login and loading user. dispatched from USERauth action
const initialState = {
    token: localStorage.getItem('token'),
    isAuth: null,
    loading: true,
    user: null
}


function auth(state = initialState, action) {

    const { type, payload } = action;

    switch(type){
        case USER_LOADED:
            return{
                ...state,
                isAuth: true,
                loading: false,
                user: payload
            }
        case USER_LOGIN_SUCCESS:
            return {
                ...state,
                isAuth: true,
                loading: false,
                user: payload,
            }
        case USER_LOGIN_FAILURE:
        case USER_AUTH_ERROR:
        case USER_LOGOUT:
            localStorage.removeItem('token');
            return {
                ...state,
                isAuth: false,
                loading: false
            }
        default:
            return state;
    }
}

export default auth;